import { render, staticRenderFns } from "./CandleImage.vue?vue&type=template&id=40719d94&scoped=true&lang=pug&"
import script from "./CandleImage.vue?vue&type=script&lang=ts&"
export * from "./CandleImage.vue?vue&type=script&lang=ts&"
import style0 from "./CandleImage.vue?vue&type=style&index=0&id=40719d94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40719d94",
  null
  
)

export default component.exports